import React from "react"

const Small = <>s</>

export default Small
